<template>
  <v-flex xs12>
    <v-card>
      <v-flex xs12 px-4 pt-4 v-if="err">
        <v-alert type="error" :value="true">{{err}}</v-alert>
      </v-flex>
      <v-card-title class="pb-0 layout row wrap px-4">
        <v-btn class="primary ma-0" @click='$router.push({ name: "newDomain" })'>{{$lang.actions.createDomain}}</v-btn>
        <v-checkbox
          color="primary"
          class="ml-3 mt-0"
          :label="$lang.labels.showActive"
          v-model="showActive"
          hide-details
        />
        <v-spacer/>
        <v-text-field
          class="min-w max-w"
          v-model="search"
          append-icon="search"
          :label="$lang.labels.search"
          hide-details />
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="showActive ? activeDomains : allDomains"
        :search="search"
        :loading="allDomains.length === 0"
        :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
      >
        <v-progress-linear height="6" slot="progress" color="primary" indeterminate />
        <template slot="items" slot-scope="props">
          <td>{{ props.item.domain }}</td>
          <td class="text-xs-left">{{ props.item.type }}</td>
          <td class="text-xs-left">{{ props.item.status }}</td>
          <td class="text-xs-left">{{ formatDate(props.item.createdOn) }}</td>
          <td class="text-xs-left min-w-lg">
            <v-btn 
              class="primary mx-0 elevation-1" 
              @click="editDomain(props.item)">
              {{$lang.actions.edit}}
            </v-btn>
            <v-btn 
              class="primary elevation-1"
              @click="changeStatus(props.item)">
              {{props.item.status === 'active' ? $lang.actions.deactivate : $lang.actions.activate}}
            </v-btn>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" type="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
    <v-dialog v-if="confirmationModal" v-model="confirmationModal" max-width="500">
      <confirmation-modal :data="confirmationData" @close="confirmationModal = false" @change="deactivate($event)"/>
    </v-dialog>
  </v-flex>
</template>

<script>
  import {baseUrl} from '../../assets/url';
  import {DateTime} from 'luxon';

  export default {
    components: {
      confirmationModal: () => import('../modals/DeactivationModal'),
    },
    data() {
      return {
        err: '',
        search: '',
        headers: [
          { text: this.$lang.labels.companyDomain, value: 'domain', align: 'left' },
          { text: this.$lang.labels.type, value: 'type', align: 'left' },
          { text: this.$lang.labels.status, value: 'status', align: 'left' },
          { text: this.$lang.labels.created, value: 'createdOn', align: 'left' },
          { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false },
        ],
        showActive: true,
        allDomains: [],
        confirmationModal: false,
        confirmationData: {
          id: null,
          url: 'domain',
        },
      };
    },
    computed: {
      activeDomains() {
        const domains = this.allDomains;
        const activeDomains = [];
        for (let i=0; domains.length > i; i++) {
          if (domains[i].status === 'active') {
            activeDomains.push(domains[i]);
          }
        }
        return activeDomains;
      },
    },
    methods: {
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd');
      },
      editDomain(domain) {
        this.$router.push({ name: 'editDomain', params: { id: domain.id }});
      },
      changeStatus(domain) {
        if (domain.status === 'inactive') {
          this.$http.post(`domain/activate/${domain.id}`)
          .then((res) => {
            if (res.body.status === 'Success') {          
              this.$set(domain, 'status', 'active');
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
        } else if (domain.status === "active") {
          this.confirmationData.id = domain.id;
          this.confirmationModal = true;
        }
      },
      deactivate(id) {
        const result = this.allDomains.find( data => data.id === id );
        this.$set(result, 'status', 'inactive');
      },
      fetchAllDomains() {
        fetch(`${baseUrl}/domain/getall`, {
          method: 'get',
          credentials: 'include',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8',
          },
        }).then((response) => {
          return response.json();
        }).then((data) => {
          if(data.error & data.error === 'Forbidden'){
            this.$router.push({ name: 'logout' })
            return;
          }
          this.allDomains = data.domains;
          localStorage.setItem('domains', JSON.stringify(data.domains));
        })
      },
    },
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
    },
    created(){
      this.fetchAllDomains();
    },
  };
</script>


// WEBPACK FOOTER //
// Domains.vue?e8bdcb18